import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, DadosCidadaoRequest } from './types';

// ACTIONS
import { dadosCidadaoSuccess, dadosCidadaoFailure } from './actions';

function* dadosCidadao(request: ReducerAction) {
	const { payload }: { payload: DadosCidadaoRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`divisao-equitativa/${CHANNEL}/dados-cidadao`,
		payload,
	);

	if (response.status === 200) {
		yield put(dadosCidadaoSuccess({ response, request: payload }));
	} else {
		yield put(dadosCidadaoFailure(response));
	}
}

export default all([takeLatest(Types.DADOS_CIDADAO_REQUEST, dadosCidadao)]);
